import * as React from "react";
var TextIcon = function TextIcon(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    id: "\\u56FE\\u5C42_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 32 32",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    xmlSpace: "preserve"
  }, props), /*#__PURE__*/React.createElement("title", null, "text-style"), /*#__PURE__*/React.createElement("g", {
    id: "text-style"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5B57\\u4F53\\u6837\\u5F0F",
    transform: "translate(3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u5F62\\u72B6",
    className: "st0",
    d: "M1.6 23.1h5l2.1-4.8h8.7l2.1 4.8h5L15.7 0h-5.3L1.6 23.1zm10.9-16h1.1l2.6 7.1H9.8l2.7-7.1z",
    style: {
      fill: props.color
    }
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u5F62\\u72B6_1_",
    className: "st0",
    d: "M21.2 32v-5h5v5h-5zm-11.1-5h5v5h-5v-5zM0 27h5v5H0v-5z",
    style: {
      fill: props.color
    }
  }))));
};
export default TextIcon;